








import { defineComponent, PropType } from "@vue/composition-api";
import { AgentEarningsTransactionDetails } from "@scrile/api-provider/dist/api/TalentAgentsProvider";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { resolveUserName } from "@/lib/userHelpers";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionAgentEarning",
  components: { TransactionView },
  props: {
    transaction: { type: Object as PropType<Transaction<AgentEarningsTransactionDetails>>, required: true },
  },
  setup() {
    return { resolveUserName };
  },
});
